// @flow
import React, { Fragment, useContext } from 'react';

import appConfig from 'Config';
import ReactAppContext from 'Context/ReactAppContext';
import { isSeller } from 'Utils/seller/sellerUtils';
import { isStrictlyProductionEnv } from 'Utils/context/contextUtils';

export const Freespee = () => {
  const appContext = useContext(ReactAppContext);
  const accountId = appConfig.get('freespee.accountId');
  if (!isStrictlyProductionEnv(appConfig) && !isSeller(appContext) && accountId) {
    return (
      <Fragment>
        <script async type="text/javascript" src="//analytics.freespee.com/js/external/fs.js" />
        <script
          dangerouslySetInnerHTML={{
            __html: `
              var __fs_conf = __fs_conf || [];
              __fs_conf.push(['setAdv',{'id': '${accountId}' }]);
          `,
          }}
        />
      </Fragment>
    );
  }
  return null;
};
